export default "__VITE_ASSET__c52309ca__"